export const BASE_URL = "https://socialmediaserver-h1ko.onrender.com";
